import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-offre',
  templateUrl: './offre.component.html',
  styleUrls: ['./offre.component.css']
})
export class OffreComponent implements OnInit {

  disabled : boolean;
  validName: string;
  duplicateName: string;
  btnModifierLabel : string;
  validationCQ: boolean = false;
  cqName: string;

  @Input('contenu') contenu : string;
  @Input('lien') lien : string;
  @Input('cq') cq : boolean = false;
  @Input('valide') valid: boolean = false;
  @Input('duplicate') duplicate: boolean = false;
  @Input('read-only') readonly: boolean = false;
  
  @Output() validChangedEvent = new EventEmitter<boolean>();
  @Output() descriptionChangedEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
    this.disabled = true;
    this.btnModifierLabel = "Modifier le contenu";
    this.validName = this.generateRandomString();
    this.duplicateName = this.generateRandomString();
    this.cqName = this.generateRandomString();
  }

  generateRandomString (length=6){
    return Math.random().toString(20).substr(2, length)
  }

  dynamicValidStyle(valid : boolean) {
    if(valid) {
      return {
        "background-color" : "mediumseagreen",
        "border-color" : "mediumseagreen",
        "min-width" : "100%",
        "font-weight" : "bold"
      }
    } else {
      return {
        "background-color" : "crimson",
        "border-color" : "crimson",
        "min-width" : "100%",
        "font-weight" : "bold"
      }
    }
  }

  setEditable() {
    this.disabled = !this.disabled;

    if(this.disabled === true) {
      this.btnModifierLabel = "Modifier le contenu";
    } else {
      this.btnModifierLabel = "Fin des modifications";
    }
  }

  validChanged(value: boolean) {
    this.validChangedEvent.emit(value);
  }

  descriptionChanged(value: string) {
    this.descriptionChangedEvent.emit(value);
  }
}
